import { render, staticRenderFns } from "./BGPRoutesLookup.vue?vue&type=template&id=439840a4&scoped=true&lang=pug&"
import script from "./BGPRoutesLookup.vue?vue&type=script&lang=js&"
export * from "./BGPRoutesLookup.vue?vue&type=script&lang=js&"
import style0 from "./BGPRoutesLookup.vue?vue&type=style&index=0&id=439840a4&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "439840a4",
  null
  
)

export default component.exports